import { numOfStepsToComplete, steps as originalSteps } from "../steps";

const createStepHeadingTitle = ({ label: _label, step }) => {
 let titleParts = {
    label: _label || "",
    stepOf: ''
}
  if (!_label || !step) {
    return titleParts
  }
  titleParts.stepOf = `Step ${step} of ${numOfStepsToComplete}`;
  const nextStep = getActiveStep({ activeStep: step })
  titleParts.nextStep = nextStep?.label ? `Next Step: ${nextStep.label}` : ""
  return titleParts
};

const determineIndexToRender = ({ stepIndex, activeStep }) => {
  return stepIndex === -1 ? 0 : activeStep;
};

const getActiveStep = ({ activeStep, steps = originalSteps }) => {
  return (
    steps.find(({ index }) => {
      return index === activeStep;
    }) ?? {}
  );
};

export { createStepHeadingTitle, determineIndexToRender, getActiveStep };
